module.exports = __webpack_public_path__ + "efd3b69f03edbdd89dad448eec0e8a4a.svg";